<template>
  <a-modal
    title="用户详情"
    :visible="open"
    :footer="null"
    width="640px"
    @cancel="onClose"
  >
    <a-spin :spinning="loading">
      <template v-if="detail">
        <a-descriptions bordered size="small" :column="2">
          <a-descriptions-item label="用户ID" :span="1">{{ detail.id }}</a-descriptions-item>
          <a-descriptions-item label="昵称" :span="1">{{ detail.nickname || '—' }}</a-descriptions-item>
          <a-descriptions-item label="邮箱" :span="2">{{ detail.email || '—' }}</a-descriptions-item>
          <a-descriptions-item label="手机号" :span="2">{{ detail.mobile || '—' }}</a-descriptions-item>
          <a-descriptions-item label="性别">{{ sexText(detail.sex) }}</a-descriptions-item>
          <a-descriptions-item label="用户状态">
            <a-tag :color="detail.status === 1 ? 'green' : 'red'">{{ detail.status === 1 ? '正常' : '禁用' }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="是否分销">
            <a-tag :color="detail.referralEnabled === 0 ? 'red' : 'green'">{{ detail.referralEnabled === 0 ? '否' : '是' }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="拉黑状态">
            <a-tag :color="detail.isBlacklisted === 1 ? 'red' : 'green'">{{ detail.isBlacklisted === 1 ? '已拉黑' : '正常' }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="注册时间">{{ parseTime(detail.createTime) }}</a-descriptions-item>
          <a-descriptions-item label="国家" :span="2">{{ detail.countryName || '—' }}</a-descriptions-item>
          <a-descriptions-item label="生日" :span="2">{{ detail.birthday || '—' }}</a-descriptions-item>
          <a-descriptions-item label="个人简介" :span="2">{{ detail.userSign || '—' }}</a-descriptions-item>
          <a-descriptions-item label="历史交易总额">
            <span class="amount-cell total">{{ formatMoney(detail.userTotalAmount) }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="钱包未提现余额">
            <span class="amount-cell wallet">{{ formatMoney(detail.money) }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="用户已提现总额" :span="2">
            <span class="amount-cell earnings">{{ formatMoney(detail.totalWithdrawnAmount) }}</span>
          </a-descriptions-item>
        </a-descriptions>
      </template>
    </a-spin>
  </a-modal>
</template>

<script>
import { getUser } from '@/api/biz/user'

export default {
  name: 'UserDetail',
  data() {
    return {
      open: false,
      loading: false,
      detail: null
    }
  },
  methods: {
    onClose() {
      this.open = false
      this.detail = null
    },
    handleOpen(record) {
      this.open = true
      this.loading = true
      this.detail = null
      getUser({ id: record.id }).then(res => {
        this.detail = res.data || null
      }).finally(() => {
        this.loading = false
      })
    },
    formatMoney(val) {
      if (val == null || val === '') return '—'
      const num = Number(val)
      if (Number.isNaN(num)) return val
      return num.toFixed(2)
    },
    sexText(sex) {
      if (sex === 1) return '男'
      if (sex === 2) return '女'
      return '保密'
    }
  }
}
</script>

<style scoped>
.amount-cell {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.amount-cell.total {
  color: #722ed1;
  font-size: 15px;
}
.amount-cell.wallet {
  color: #1890ff;
  font-size: 15px;
}
.amount-cell.earnings {
  color: #52c41a;
  font-size: 15px;
}
</style>
